import {
  Box,
  CircularProgress,
  CircularProgressProps,
  SxProps,
  Theme,
  Typography,
} from "@mui/material";
import styles from "./Loading.styles";

type TLoadingProps = {
  sx?: SxProps<Theme>;
  size?: number | string;
  color?: CircularProgressProps["color"];
  message?: string;
};

const Loading = ({
  sx = styles.container,
  size = "26px",
  color,
  message,
}: TLoadingProps) => {
  return (
    <Box component="span" sx={sx} data-qaid="loading">
      <CircularProgress size={size} color={color} aria-label="loading" />
      {message && (
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default Loading;
